import React, { Component } from 'react'

import { Card, Form, Button, Input, message } from 'antd'
import { connect } from 'react-redux'

import storageUtils from '../../utils/storageUtils'
import { req_add_eps_links } from '../../api'

const Item = Form.Item

class IntroductionlinkAddModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////  
    state = {
        item: {}
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_add_item = async (item) => {
        const result = await req_add_eps_links(item, storageUtils.getUser().token)
        if (result.status === "success") {
            message.success(result.message)
        } else {
            message.error(result.message)
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

  

    // 操作互動處理 //////////////////////////////////////////////

    onFinish = (values) => {
        //console.log('Success:', values);
        const { userCode } = storageUtils.getUser()
        const { LinkDescription, LinkUrl } = values

        const item = {
            BloggerCode: userCode,
            LinkDescription: LinkDescription,
            LinkUrl: LinkUrl,
        }
        //console.log(bulletinBoard)
        this.api_add_item(item)
    }

    /////////////////////////////////////////////////////////// 

    render() {
        const { LinkDescription, LinkUrl } = this.state.item
        return (
            <Card>
                <Form
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Item
                        label="連結名稱"
                        name="LinkDescription"
                        initialValue={LinkDescription}
                        rules={[
                            { required: true, whitespace: true, message: '必須填寫連結名稱' },
                        ]}
                    >
                        <Input placeholder="輸入連結名稱" />
                    </Item>
                    <Item
                        label="連結網址"
                        name="LinkUrl"
                        initialValue={LinkUrl}
                        rules={[
                            { required: true, whitespace: true, message: '必須填寫網址' },
                        ]}
                    >
                        <Input placeholder="輸入網址內容" />
                    </Item>
                    <Item>
                        <Button type='primary' htmlType="submit" block>送出</Button>
                    </Item>
                </Form>
            </Card>
        )
    }
}


export default connect(
    state => ({ user: state.user }),
    {}
)(IntroductionlinkAddModal)